/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GenericResponseDTO } from '../model/generic-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { GiornoDellaSettimanaEnum } from '../model/giorno-della-settimana-enum';
// @ts-ignore
import { ServizioMensaAllineaScuoleDTO } from '../model/servizio-mensa-allinea-scuole-dto';
// @ts-ignore
import { ServizioMensaCalendarioScolasticoDTO } from '../model/servizio-mensa-calendario-scolastico-dto';
// @ts-ignore
import { ServizioMensaCalendarioScolasticoForm } from '../model/servizio-mensa-calendario-scolastico-form';
// @ts-ignore
import { ServizioMensaChiusuraScolasticaDTO } from '../model/servizio-mensa-chiusura-scolastica-dto';
// @ts-ignore
import { ServizioMensaChiusuraScolasticaForm } from '../model/servizio-mensa-chiusura-scolastica-form';
// @ts-ignore
import { ServizioMensaChiusuraScolasticaUpdateForm } from '../model/servizio-mensa-chiusura-scolastica-update-form';
// @ts-ignore
import { ServizioMensaChiusureScolasticheBulkForm } from '../model/servizio-mensa-chiusure-scolastiche-bulk-form';
// @ts-ignore
import { ServizioMensaChiusureSettimanaliForm } from '../model/servizio-mensa-chiusure-settimanali-form';
// @ts-ignore
import { ServizioMensaPastiDipendentiDTO } from '../model/servizio-mensa-pasti-dipendenti-dto';
// @ts-ignore
import { ServizioMensaPastiDipendentiUpsertForm } from '../model/servizio-mensa-pasti-dipendenti-upsert-form';
// @ts-ignore
import { ServizioMensaScuolaDTO } from '../model/servizio-mensa-scuola-dto';
// @ts-ignore
import { ServizioMensaSezioneClasseDTO } from '../model/servizio-mensa-sezione-classe-dto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    ServizioMensaScuoleServiceInterface,
    AddServizioMensaScuolaCalendarioScolasticoRequestParams,
    AddServizioMensaScuolaChiusuraScolasticaRequestParams,
    AddServizioMensaScuoleChiusureScolasticheRequestParams,
    AllineaServizioMensaScuoleDaBandoRequestParams,
    ClonaServizioMensaScuolaCalendarioScolasticoRequestParams,
    EditServizioMensaScuolaCalendarioScolasticoRequestParams,
    EditServizioMensaScuolaChiusuraScolasticaRequestParams,
    GetServizioMensaScuolaCalendarioScolasticoRequestParams,
    GetServizioMensaScuolaPastiDipendentiRequestParams,
    GetServizioMensaScuolaSezioniClassiRequestParams,
    ListServizioMensaScuoleRequestParams,
    RemoveServizioMensaScuolaChiusuraScolasticaRequestParams,
    ReplaceServizioMensaScuolaChiusureSettimanaliRequestParams,
    SetServizioMensaScuolaNumeroMinimoPastiDaFatturareRequestParams,
    SetServizioMensaScuolaPastiDipendentiRequestParams
} from './servizio-mensa-scuole.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class ServizioMensaScuoleService extends BaseService implements ServizioMensaScuoleServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Crea il calendario scolastico reference di una scuola del servizio mensa.
     * Crea il calendario 1:1 con data inizio/fine (dd/MM/yyyy). Calendario già esistente → 400; data_fine precedente a data_inizio → 400. Nessun seed automatico dalle date del servizio. Audience ADMIN/SUPERADMIN/OP_SCUOLA/OP_COMUNE.
     * @endpoint post /api/v1/servizi/mensa/scuole/{id_scuola}/calendario-scolastico
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public addServizioMensaScuolaCalendarioScolastico(requestParameters: AddServizioMensaScuolaCalendarioScolasticoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioMensaCalendarioScolasticoDTO>;
    public addServizioMensaScuolaCalendarioScolastico(requestParameters: AddServizioMensaScuolaCalendarioScolasticoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioMensaCalendarioScolasticoDTO>>;
    public addServizioMensaScuolaCalendarioScolastico(requestParameters: AddServizioMensaScuolaCalendarioScolasticoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioMensaCalendarioScolasticoDTO>>;
    public addServizioMensaScuolaCalendarioScolastico(requestParameters: AddServizioMensaScuolaCalendarioScolasticoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idScuola = requestParameters?.idScuola;
        if (idScuola === null || idScuola === undefined) {
            throw new Error('Required parameter idScuola was null or undefined when calling addServizioMensaScuolaCalendarioScolastico.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling addServizioMensaScuolaCalendarioScolastico.');
        }
        const servizioMensaCalendarioScolasticoForm = requestParameters?.servizioMensaCalendarioScolasticoForm;
        if (servizioMensaCalendarioScolasticoForm === null || servizioMensaCalendarioScolasticoForm === undefined) {
            throw new Error('Required parameter servizioMensaCalendarioScolasticoForm was null or undefined when calling addServizioMensaScuolaCalendarioScolastico.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/scuole/${this.configuration.encodeParam({name: "idScuola", value: idScuola, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/calendario-scolastico`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioMensaCalendarioScolasticoDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: servizioMensaCalendarioScolasticoForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Crea chiusure scolastiche puntuali (range espanso per-giorno).
     * Accetta un range data_inizio/data_fine (+ classe/sezione/motivazione opzionali) e lo espande in una riga per giorno, saltando i giorni in chiusura settimanale. In alternativa a classe/sezione, la lista classi chiude più classi in una sola richiesta, all-or-nothing (classi + classe/sezione, lista vuota o voce vuota → 400). Range fuori finestra calendario → 400; collisione stessa data+scope → 400; nessun gate anti-passato (la retroattività innesca il ricalcolo derivato). Audience ADMIN/SUPERADMIN/OP_SCUOLA/OP_COMUNE.
     * @endpoint post /api/v1/servizi/mensa/scuole/{id_scuola}/chiusura-scolastica
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public addServizioMensaScuolaChiusuraScolastica(requestParameters: AddServizioMensaScuolaChiusuraScolasticaRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<ServizioMensaChiusuraScolasticaDTO>>;
    public addServizioMensaScuolaChiusuraScolastica(requestParameters: AddServizioMensaScuolaChiusuraScolasticaRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<ServizioMensaChiusuraScolasticaDTO>>>;
    public addServizioMensaScuolaChiusuraScolastica(requestParameters: AddServizioMensaScuolaChiusuraScolasticaRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<ServizioMensaChiusuraScolasticaDTO>>>;
    public addServizioMensaScuolaChiusuraScolastica(requestParameters: AddServizioMensaScuolaChiusuraScolasticaRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idScuola = requestParameters?.idScuola;
        if (idScuola === null || idScuola === undefined) {
            throw new Error('Required parameter idScuola was null or undefined when calling addServizioMensaScuolaChiusuraScolastica.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling addServizioMensaScuolaChiusuraScolastica.');
        }
        const servizioMensaChiusuraScolasticaForm = requestParameters?.servizioMensaChiusuraScolasticaForm;
        if (servizioMensaChiusuraScolasticaForm === null || servizioMensaChiusuraScolasticaForm === undefined) {
            throw new Error('Required parameter servizioMensaChiusuraScolasticaForm was null or undefined when calling addServizioMensaScuolaChiusuraScolastica.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/scuole/${this.configuration.encodeParam({name: "idScuola", value: idScuola, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/chiusura-scolastica`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<ServizioMensaChiusuraScolasticaDTO>>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: servizioMensaChiusuraScolasticaForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Crea chiusure scolastiche in blocco sulle scuole del servizio.
     * Stesso payload del POST singolo + scuole_ids opzionale (assente → tutte le scuole del servizio; presente → subset validato within-servizio, id estraneo → 404). All-or-nothing: una collisione o una scuola senza calendario fa fallire l\&#39;intero bulk, col nome della scuola colpita. Erede di POST /api/v1/scuola/chiusura-scolastica-for-all, riscopato dal cross-comune al servizio. Audience ADMIN/SUPERADMIN/OP_SCUOLA/OP_COMUNE.
     * @endpoint post /api/v1/servizi/mensa/scuole/chiusure-scolastiche
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public addServizioMensaScuoleChiusureScolastiche(requestParameters: AddServizioMensaScuoleChiusureScolasticheRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<GenericResponseDTO>;
    public addServizioMensaScuoleChiusureScolastiche(requestParameters: AddServizioMensaScuoleChiusureScolasticheRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GenericResponseDTO>>;
    public addServizioMensaScuoleChiusureScolastiche(requestParameters: AddServizioMensaScuoleChiusureScolasticheRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GenericResponseDTO>>;
    public addServizioMensaScuoleChiusureScolastiche(requestParameters: AddServizioMensaScuoleChiusureScolasticheRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling addServizioMensaScuoleChiusureScolastiche.');
        }
        const servizioMensaChiusureScolasticheBulkForm = requestParameters?.servizioMensaChiusureScolasticheBulkForm;
        if (servizioMensaChiusureScolasticheBulkForm === null || servizioMensaChiusureScolasticheBulkForm === undefined) {
            throw new Error('Required parameter servizioMensaChiusureScolasticheBulkForm was null or undefined when calling addServizioMensaScuoleChiusureScolastiche.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/scuole/chiusure-scolastiche`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<GenericResponseDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: servizioMensaChiusureScolasticheBulkForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Allinea le scuole del servizio ai plessi attivi del bando.
     * Materializza le ServizioMensaScuola mancanti per i plessi L2 attivi del bando associato al servizio header. Idempotente: le scuole già presenti non vengono duplicate né modificate, e le scuole di plessi poi disattivati NON vengono rimosse (conservano studenti, calendario e pasti configurati). Serve a recuperare i bandi rimasti disallineati, quando i plessi erano stati aggiunti prima che la materializzazione per-plesso esistesse. Ritorna i conteggi: scuole_create&#x3D;0 con plessi_attivi&gt;0 significa che era già tutto allineato. Audience ADMIN/SUPERADMIN/OP_COMUNE.
     * @endpoint post /api/v1/servizi/mensa/scuole/allinea-da-bando
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public allineaServizioMensaScuoleDaBando(requestParameters: AllineaServizioMensaScuoleDaBandoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioMensaAllineaScuoleDTO>;
    public allineaServizioMensaScuoleDaBando(requestParameters: AllineaServizioMensaScuoleDaBandoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioMensaAllineaScuoleDTO>>;
    public allineaServizioMensaScuoleDaBando(requestParameters: AllineaServizioMensaScuoleDaBandoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioMensaAllineaScuoleDTO>>;
    public allineaServizioMensaScuoleDaBando(requestParameters: AllineaServizioMensaScuoleDaBandoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling allineaServizioMensaScuoleDaBando.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/scuole/allinea-da-bando`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioMensaAllineaScuoleDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Clona il calendario scolastico da un\&#39;altra scuola dello stesso servizio.
     * Copia bound + chiusure puntuali + chiusure settimanali dalla scuola sorgente (anti-IDOR: sorgente di altro servizio → 404). Con calendario destinazione esistente serve forced&#x3D;true (replace con orphanRemoval); su replace forced i giorni passati riclassificati innescano il ricalcolo derivato conservativo. Audience ADMIN/SUPERADMIN/OP_SCUOLA/OP_COMUNE.
     * @endpoint put /api/v1/servizi/mensa/scuole/{id_scuola}/calendario-scolastico/clona
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public clonaServizioMensaScuolaCalendarioScolastico(requestParameters: ClonaServizioMensaScuolaCalendarioScolasticoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioMensaCalendarioScolasticoDTO>;
    public clonaServizioMensaScuolaCalendarioScolastico(requestParameters: ClonaServizioMensaScuolaCalendarioScolasticoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioMensaCalendarioScolasticoDTO>>;
    public clonaServizioMensaScuolaCalendarioScolastico(requestParameters: ClonaServizioMensaScuolaCalendarioScolasticoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioMensaCalendarioScolasticoDTO>>;
    public clonaServizioMensaScuolaCalendarioScolastico(requestParameters: ClonaServizioMensaScuolaCalendarioScolasticoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idScuola = requestParameters?.idScuola;
        if (idScuola === null || idScuola === undefined) {
            throw new Error('Required parameter idScuola was null or undefined when calling clonaServizioMensaScuolaCalendarioScolastico.');
        }
        const idScuolaDaClonare = requestParameters?.idScuolaDaClonare;
        if (idScuolaDaClonare === null || idScuolaDaClonare === undefined) {
            throw new Error('Required parameter idScuolaDaClonare was null or undefined when calling clonaServizioMensaScuolaCalendarioScolastico.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling clonaServizioMensaScuolaCalendarioScolastico.');
        }
        const forced = requestParameters?.forced;

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'id_scuola_da_clonare',
            <any>idScuolaDaClonare,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'forced',
            <any>forced,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/scuole/${this.configuration.encodeParam({name: "idScuola", value: idScuola, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/calendario-scolastico/clona`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioMensaCalendarioScolasticoDTO>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Aggiorna le date del calendario scolastico di una scuola del servizio mensa.
     * Aggiorna data inizio/fine. Nuovo range che esclude chiusure puntuali esistenti → 400 dedicato. I giorni riclassificati passati innescano il ricalcolo derivato (storico, portafogli, rendicontazione) nella stessa transazione. Audience ADMIN/SUPERADMIN/OP_SCUOLA/OP_COMUNE.
     * @endpoint put /api/v1/servizi/mensa/scuole/{id_scuola}/calendario-scolastico
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public editServizioMensaScuolaCalendarioScolastico(requestParameters: EditServizioMensaScuolaCalendarioScolasticoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioMensaCalendarioScolasticoDTO>;
    public editServizioMensaScuolaCalendarioScolastico(requestParameters: EditServizioMensaScuolaCalendarioScolasticoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioMensaCalendarioScolasticoDTO>>;
    public editServizioMensaScuolaCalendarioScolastico(requestParameters: EditServizioMensaScuolaCalendarioScolasticoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioMensaCalendarioScolasticoDTO>>;
    public editServizioMensaScuolaCalendarioScolastico(requestParameters: EditServizioMensaScuolaCalendarioScolasticoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idScuola = requestParameters?.idScuola;
        if (idScuola === null || idScuola === undefined) {
            throw new Error('Required parameter idScuola was null or undefined when calling editServizioMensaScuolaCalendarioScolastico.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling editServizioMensaScuolaCalendarioScolastico.');
        }
        const servizioMensaCalendarioScolasticoForm = requestParameters?.servizioMensaCalendarioScolasticoForm;
        if (servizioMensaCalendarioScolasticoForm === null || servizioMensaCalendarioScolasticoForm === undefined) {
            throw new Error('Required parameter servizioMensaCalendarioScolasticoForm was null or undefined when calling editServizioMensaScuolaCalendarioScolastico.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/scuole/${this.configuration.encodeParam({name: "idScuola", value: idScuola, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/calendario-scolastico`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioMensaCalendarioScolasticoDTO>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: servizioMensaCalendarioScolasticoForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Modifica una singola riga di chiusura scolastica puntuale.
     * Edita data, scope classe/sezione e motivazione della riga per-giorno (cambio contratto vs il legacy a range). Data fuori finestra → 400; collisione → 400. Su riclassificazione passata il ricalcolo gira sull\&#39;unione delle coorti vecchio+nuovo scope. Audience ADMIN/SUPERADMIN/OP_SCUOLA/OP_COMUNE.
     * @endpoint put /api/v1/servizi/mensa/scuole/{id_scuola}/chiusura-scolastica/{id_chiusura_scolastica}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public editServizioMensaScuolaChiusuraScolastica(requestParameters: EditServizioMensaScuolaChiusuraScolasticaRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioMensaChiusuraScolasticaDTO>;
    public editServizioMensaScuolaChiusuraScolastica(requestParameters: EditServizioMensaScuolaChiusuraScolasticaRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioMensaChiusuraScolasticaDTO>>;
    public editServizioMensaScuolaChiusuraScolastica(requestParameters: EditServizioMensaScuolaChiusuraScolasticaRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioMensaChiusuraScolasticaDTO>>;
    public editServizioMensaScuolaChiusuraScolastica(requestParameters: EditServizioMensaScuolaChiusuraScolasticaRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idScuola = requestParameters?.idScuola;
        if (idScuola === null || idScuola === undefined) {
            throw new Error('Required parameter idScuola was null or undefined when calling editServizioMensaScuolaChiusuraScolastica.');
        }
        const idChiusuraScolastica = requestParameters?.idChiusuraScolastica;
        if (idChiusuraScolastica === null || idChiusuraScolastica === undefined) {
            throw new Error('Required parameter idChiusuraScolastica was null or undefined when calling editServizioMensaScuolaChiusuraScolastica.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling editServizioMensaScuolaChiusuraScolastica.');
        }
        const servizioMensaChiusuraScolasticaUpdateForm = requestParameters?.servizioMensaChiusuraScolasticaUpdateForm;
        if (servizioMensaChiusuraScolasticaUpdateForm === null || servizioMensaChiusuraScolasticaUpdateForm === undefined) {
            throw new Error('Required parameter servizioMensaChiusuraScolasticaUpdateForm was null or undefined when calling editServizioMensaScuolaChiusuraScolastica.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/scuole/${this.configuration.encodeParam({name: "idScuola", value: idScuola, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/chiusura-scolastica/${this.configuration.encodeParam({name: "idChiusuraScolastica", value: idChiusuraScolastica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioMensaChiusuraScolasticaDTO>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: servizioMensaChiusuraScolasticaUpdateForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Vista completa del calendario scolastico di una scuola del servizio mensa.
     * Bound + TUTTE le chiusure puntuali (con scope classe/sezione e motivazione) + chiusure settimanali — gemello operatore non filtrato del calendario-mensa cittadino. Calendario assente → 404. Audience ADMIN/SUPERADMIN/OP_SCUOLA/OP_COMUNE.
     * @endpoint get /api/v1/servizi/mensa/scuole/{id_scuola}/calendario-scolastico
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getServizioMensaScuolaCalendarioScolastico(requestParameters: GetServizioMensaScuolaCalendarioScolasticoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioMensaCalendarioScolasticoDTO>;
    public getServizioMensaScuolaCalendarioScolastico(requestParameters: GetServizioMensaScuolaCalendarioScolasticoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioMensaCalendarioScolasticoDTO>>;
    public getServizioMensaScuolaCalendarioScolastico(requestParameters: GetServizioMensaScuolaCalendarioScolasticoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioMensaCalendarioScolasticoDTO>>;
    public getServizioMensaScuolaCalendarioScolastico(requestParameters: GetServizioMensaScuolaCalendarioScolasticoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idScuola = requestParameters?.idScuola;
        if (idScuola === null || idScuola === undefined) {
            throw new Error('Required parameter idScuola was null or undefined when calling getServizioMensaScuolaCalendarioScolastico.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling getServizioMensaScuolaCalendarioScolastico.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/scuole/${this.configuration.encodeParam({name: "idScuola", value: idScuola, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/calendario-scolastico`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioMensaCalendarioScolasticoDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Legge la configurazione pasti dipendenti di una scuola del servizio mensa.
     * Ritorna i totali per-categoria e i menu non ordinari della scuola indicata, scopata dall\&#39;header Gestione-Mense-Servizio-Id. Audience ADMIN/SUPERADMIN/OP_SCUOLA/OP_COMUNE.
     * @endpoint get /api/v1/servizi/mensa/scuole/{id_scuola}/pasti-dipendenti
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getServizioMensaScuolaPastiDipendenti(requestParameters: GetServizioMensaScuolaPastiDipendentiRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioMensaPastiDipendentiDTO>;
    public getServizioMensaScuolaPastiDipendenti(requestParameters: GetServizioMensaScuolaPastiDipendentiRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioMensaPastiDipendentiDTO>>;
    public getServizioMensaScuolaPastiDipendenti(requestParameters: GetServizioMensaScuolaPastiDipendentiRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioMensaPastiDipendentiDTO>>;
    public getServizioMensaScuolaPastiDipendenti(requestParameters: GetServizioMensaScuolaPastiDipendentiRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idScuola = requestParameters?.idScuola;
        if (idScuola === null || idScuola === undefined) {
            throw new Error('Required parameter idScuola was null or undefined when calling getServizioMensaScuolaPastiDipendenti.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling getServizioMensaScuolaPastiDipendenti.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/scuole/${this.configuration.encodeParam({name: "idScuola", value: idScuola, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/pasti-dipendenti`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioMensaPastiDipendentiDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Sezioni e classi configurate di una scuola del servizio mensa.
     * Ritorna le coppie distinte (classe, sezione) delle assegnazioni L3 attive del plesso origine (sezione null &#x3D; classe intera; la riga plesso-wide è esclusa). Derivazione dal CONFIGURATO del bando, non dagli studenti iscritti: una sezione senza iscritti appare. Audience ADMIN/SUPERADMIN/OP_SCUOLA/OP_COMUNE.
     * @endpoint get /api/v1/servizi/mensa/scuole/{id_scuola}/sezioni-classi
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getServizioMensaScuolaSezioniClassi(requestParameters: GetServizioMensaScuolaSezioniClassiRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<ServizioMensaSezioneClasseDTO>>;
    public getServizioMensaScuolaSezioniClassi(requestParameters: GetServizioMensaScuolaSezioniClassiRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<ServizioMensaSezioneClasseDTO>>>;
    public getServizioMensaScuolaSezioniClassi(requestParameters: GetServizioMensaScuolaSezioniClassiRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<ServizioMensaSezioneClasseDTO>>>;
    public getServizioMensaScuolaSezioniClassi(requestParameters: GetServizioMensaScuolaSezioniClassiRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idScuola = requestParameters?.idScuola;
        if (idScuola === null || idScuola === undefined) {
            throw new Error('Required parameter idScuola was null or undefined when calling getServizioMensaScuolaSezioniClassi.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling getServizioMensaScuolaSezioniClassi.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/scuole/${this.configuration.encodeParam({name: "idScuola", value: idScuola, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/sezioni-classi`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<ServizioMensaSezioneClasseDTO>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lista delle scuole del servizio mensa.
     * Ritorna le scuole materializzate del servizio header, con identità risolta dal plesso L2 origine del bando (nome, ordinamento, indirizzo, codice meccanografico) e nome dell\&#39;istituto L1 di appartenenza, numero minimo pasti da fatturare e presenza del calendario. Erede di GET /api/v1/scuola/{slugComune}/dettagli-scuole, riscopato dal comune al servizio. Audience ADMIN/SUPERADMIN/OP_SCUOLA/OP_COMUNE.
     * @endpoint get /api/v1/servizi/mensa/scuole
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listServizioMensaScuole(requestParameters: ListServizioMensaScuoleRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<ServizioMensaScuolaDTO>>;
    public listServizioMensaScuole(requestParameters: ListServizioMensaScuoleRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<ServizioMensaScuolaDTO>>>;
    public listServizioMensaScuole(requestParameters: ListServizioMensaScuoleRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<ServizioMensaScuolaDTO>>>;
    public listServizioMensaScuole(requestParameters: ListServizioMensaScuoleRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling listServizioMensaScuole.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/scuole`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<ServizioMensaScuolaDTO>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Elimina una singola riga di chiusura scolastica puntuale.
     * Rimuove la riga per-giorno. La delete di una chiusura passata ripristina i giorni-mensa e ri-deriva storico/portafogli/rendicontazione della coorte matchata. Audience ADMIN/SUPERADMIN.
     * @endpoint delete /api/v1/servizi/mensa/scuole/{id_scuola}/chiusura-scolastica/{id_chiusura_scolastica}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public removeServizioMensaScuolaChiusuraScolastica(requestParameters: RemoveServizioMensaScuolaChiusuraScolasticaRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<GenericResponseDTO>;
    public removeServizioMensaScuolaChiusuraScolastica(requestParameters: RemoveServizioMensaScuolaChiusuraScolasticaRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GenericResponseDTO>>;
    public removeServizioMensaScuolaChiusuraScolastica(requestParameters: RemoveServizioMensaScuolaChiusuraScolasticaRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GenericResponseDTO>>;
    public removeServizioMensaScuolaChiusuraScolastica(requestParameters: RemoveServizioMensaScuolaChiusuraScolasticaRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idScuola = requestParameters?.idScuola;
        if (idScuola === null || idScuola === undefined) {
            throw new Error('Required parameter idScuola was null or undefined when calling removeServizioMensaScuolaChiusuraScolastica.');
        }
        const idChiusuraScolastica = requestParameters?.idChiusuraScolastica;
        if (idChiusuraScolastica === null || idChiusuraScolastica === undefined) {
            throw new Error('Required parameter idChiusuraScolastica was null or undefined when calling removeServizioMensaScuolaChiusuraScolastica.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling removeServizioMensaScuolaChiusuraScolastica.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/scuole/${this.configuration.encodeParam({name: "idScuola", value: idScuola, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/chiusura-scolastica/${this.configuration.encodeParam({name: "idChiusuraScolastica", value: idChiusuraScolastica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<GenericResponseDTO>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Sostituisce i giorni ricorrenti di chiusura settimanale di una scuola.
     * Replace completo dell\&#39;insieme dei giorni (UNIQUE per giorno). Lista vuota → 400. Per ogni weekday aggiunto/rimosso le occorrenze passate nel range del calendario innescano il ricalcolo derivato su coorte scuola-intera. Erede di PUT .../giorni-della-settimana-di-chiusura. Audience ADMIN/SUPERADMIN/OP_SCUOLA/OP_COMUNE.
     * @endpoint put /api/v1/servizi/mensa/scuole/{id_scuola}/chiusure-settimanali
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public replaceServizioMensaScuolaChiusureSettimanali(requestParameters: ReplaceServizioMensaScuolaChiusureSettimanaliRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<GiornoDellaSettimanaEnum>>;
    public replaceServizioMensaScuolaChiusureSettimanali(requestParameters: ReplaceServizioMensaScuolaChiusureSettimanaliRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<GiornoDellaSettimanaEnum>>>;
    public replaceServizioMensaScuolaChiusureSettimanali(requestParameters: ReplaceServizioMensaScuolaChiusureSettimanaliRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<GiornoDellaSettimanaEnum>>>;
    public replaceServizioMensaScuolaChiusureSettimanali(requestParameters: ReplaceServizioMensaScuolaChiusureSettimanaliRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idScuola = requestParameters?.idScuola;
        if (idScuola === null || idScuola === undefined) {
            throw new Error('Required parameter idScuola was null or undefined when calling replaceServizioMensaScuolaChiusureSettimanali.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling replaceServizioMensaScuolaChiusureSettimanali.');
        }
        const servizioMensaChiusureSettimanaliForm = requestParameters?.servizioMensaChiusureSettimanaliForm;
        if (servizioMensaChiusureSettimanaliForm === null || servizioMensaChiusureSettimanaliForm === undefined) {
            throw new Error('Required parameter servizioMensaChiusureSettimanaliForm was null or undefined when calling replaceServizioMensaScuolaChiusureSettimanali.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/scuole/${this.configuration.encodeParam({name: "idScuola", value: idScuola, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/chiusure-settimanali`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<GiornoDellaSettimanaEnum>>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: servizioMensaChiusureSettimanaliForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Imposta il numero minimo di pasti da fatturare per una scuola.
     * Scrive il campo reference letto dal runtime pasti. Disponibile solo per servizi con gestione manuale attiva (400 altrimenti); valore negativo → 400; null rimuove il limite. Audience ADMIN/SUPERADMIN/OP_COMUNE.
     * @endpoint put /api/v1/servizi/mensa/scuole/{id_scuola}/numero-minimo-pasti-da-fatturare
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public setServizioMensaScuolaNumeroMinimoPastiDaFatturare(requestParameters: SetServizioMensaScuolaNumeroMinimoPastiDaFatturareRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<GenericResponseDTO>;
    public setServizioMensaScuolaNumeroMinimoPastiDaFatturare(requestParameters: SetServizioMensaScuolaNumeroMinimoPastiDaFatturareRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GenericResponseDTO>>;
    public setServizioMensaScuolaNumeroMinimoPastiDaFatturare(requestParameters: SetServizioMensaScuolaNumeroMinimoPastiDaFatturareRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GenericResponseDTO>>;
    public setServizioMensaScuolaNumeroMinimoPastiDaFatturare(requestParameters: SetServizioMensaScuolaNumeroMinimoPastiDaFatturareRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idScuola = requestParameters?.idScuola;
        if (idScuola === null || idScuola === undefined) {
            throw new Error('Required parameter idScuola was null or undefined when calling setServizioMensaScuolaNumeroMinimoPastiDaFatturare.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling setServizioMensaScuolaNumeroMinimoPastiDaFatturare.');
        }
        const numeroMinimoPastiDaFatturare = requestParameters?.numeroMinimoPastiDaFatturare;

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'numeroMinimoPastiDaFatturare',
            <any>numeroMinimoPastiDaFatturare,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/scuole/${this.configuration.encodeParam({name: "idScuola", value: idScuola, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/numero-minimo-pasti-da-fatturare`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<GenericResponseDTO>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Crea o aggiorna la configurazione pasti dipendenti di una scuola del servizio mensa.
     * Upsert con replace completo di categorie e menu non ordinari. Valida la congruenza dei totali per categoria (400 numero_pasti_incronguente). Audience ADMIN/SUPERADMIN/OP_SCUOLA/OP_COMUNE.
     * @endpoint put /api/v1/servizi/mensa/scuole/{id_scuola}/pasti-dipendenti
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public setServizioMensaScuolaPastiDipendenti(requestParameters: SetServizioMensaScuolaPastiDipendentiRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioMensaPastiDipendentiDTO>;
    public setServizioMensaScuolaPastiDipendenti(requestParameters: SetServizioMensaScuolaPastiDipendentiRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioMensaPastiDipendentiDTO>>;
    public setServizioMensaScuolaPastiDipendenti(requestParameters: SetServizioMensaScuolaPastiDipendentiRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioMensaPastiDipendentiDTO>>;
    public setServizioMensaScuolaPastiDipendenti(requestParameters: SetServizioMensaScuolaPastiDipendentiRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idScuola = requestParameters?.idScuola;
        if (idScuola === null || idScuola === undefined) {
            throw new Error('Required parameter idScuola was null or undefined when calling setServizioMensaScuolaPastiDipendenti.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling setServizioMensaScuolaPastiDipendenti.');
        }
        const servizioMensaPastiDipendentiUpsertForm = requestParameters?.servizioMensaPastiDipendentiUpsertForm;
        if (servizioMensaPastiDipendentiUpsertForm === null || servizioMensaPastiDipendentiUpsertForm === undefined) {
            throw new Error('Required parameter servizioMensaPastiDipendentiUpsertForm was null or undefined when calling setServizioMensaScuolaPastiDipendenti.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/scuole/${this.configuration.encodeParam({name: "idScuola", value: idScuola, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/pasti-dipendenti`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioMensaPastiDipendentiDTO>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: servizioMensaPastiDipendentiUpsertForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
